import App from 'app/app.js';
import 'app/directive/LtPortraitPictureDayIdInputCtrl.js';
import template from 'html/claim/lt-portrait-picture-day-id-input.html';

function LtPortraitPictureDayIdInputDirective() {
  return {
    restrict: 'E',
    require: ['ltPortraitPictureDayIdInput'],
    scope: {
      ltId: '@',
      ltName: '@',
      ltPortraitId: '@',
      fieldsetClass: '@',
      fieldsetDynamicClass: '@',
      pidHelper: '@',
      lifetouchCode: '=',
      onChange: '&',
      inputDisabled: '<'
    },
    controller: 'LtPortraitPictureDayIdInputCtrl',
    controllerAs: 'ctrl',
    template
  };
}

App.directive('ltPortraitPictureDayIdInput', [LtPortraitPictureDayIdInputDirective]);
